import { Box, Checkbox, Typography,Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import useAxios from "../../helpers/Hooks/useAxios";
import { URLS } from "../../helpers/URLS";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import NoData from '../../loaders/NoData';
import EmpTimeSheetReport from "../EmpTimeSheetReport";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedEmpsForTimeSheetApprove } from "../../Redux/reducer";
import './style.css'
import '../../assets/scss/tables.scss'

const initials = (name) => {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  return ((parts[0] ? parts[0][0] : "") +
    (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
};


const TeamTimeSheets = ({ userInfo }) => {
const { fetchData } = useAxios();
const [empTimeSheetReports , setEmpTimeSheetReports]=useState([])
const [selectedEmps , setSelectedEmps]=useState([])
const { selectedEmpsForTimeSheetApprove } = useSelector((state) => {
    return state.WorkHubAppSlice;
  });

const dispatch=useDispatch()

  useEffect(() => {
    getTeamTimeSheets();
  }, []);

  const getTeamTimeSheets = async () => {
    try {
      let teamReports = await fetchData({
        url: URLS.TeamTimeSheets,
        method: "get",
      });
      //console.log(teamReports, "teamReports");
      handelSegrigateBasedOnEmp(teamReports)
    } catch (error) {
      console.log(error, "error");
    }
  };

const handelSegrigateBasedOnEmp=async(data)=>{
try{
    let empArray = [];
    data?.map((each)=>{
        if(empArray?.find((emp)=>emp?.EmpName == each?.employeeName)){
          let indexOfExistingEmp = empArray?.findIndex((empData) => empData?.EmpName === each?.employeeName)
          if(indexOfExistingEmp == -1){
            return 
          }
          empArray[indexOfExistingEmp].reports= [...empArray[indexOfExistingEmp].reports , each]
        }
        else{
            empArray.push({EmpName:each?.employeeName , reports:[each] })
        }
    })
    setEmpTimeSheetReports(empArray)
    //console.log(empArray , 'empwise')
}
catch(error){
console.log(error , 'error')
}
} 

const handleCheckboxClick = (e, empName) => {
const isChecked = e.target.checked;
let updatedEmps = [...selectedEmps] ;


if(isChecked && !updatedEmps.includes(empName)){
    updatedEmps.push(empName)
}
else{
    updatedEmps = updatedEmps.filter((emp) => emp !== empName);
}
// console.log(updatedEmps , 'updatedEmps')
setSelectedEmps([...updatedEmps])
dispatch(setSelectedEmpsForTimeSheetApprove(updatedEmps))
};



const handleApproveAll = async()=>{
    try{
//console.log(selectedEmpsForTimeSheetApprove , 'selectedEmpsForTimeSheetApprove')
let body={selectedEmps:selectedEmpsForTimeSheetApprove}
let approveAll = await fetchData({url:URLS.ApproveAll , method:'put' , body:body})
getTeamTimeSheets()
dispatch(setSelectedEmpsForTimeSheetApprove([]))
    }
    catch(error){

    }
}



  const pendingWeeks = empTimeSheetReports.reduce(
    (total, emp) => total + (emp?.reports?.length || 0), 0);

  const selectedCount = selectedEmpsForTimeSheetApprove?.length || 0;

  return <div className="wh-table ts-approvals">

    {empTimeSheetReports.length > 0 && (
      <div className="ts-approvals-bar">
        <span className="ts-approvals-summary">
          <PeopleAltOutlinedIcon />
          <b>{empTimeSheetReports.length}</b>
          {empTimeSheetReports.length === 1 ? 'person' : 'people'}
          <em>·</em>
          <b>{pendingWeeks}</b>
          {pendingWeeks === 1 ? 'week' : 'weeks'} waiting
        </span>

        {selectedCount > 0 && (
          <Box className="approve-all">
            <span className="wh-pill">{selectedCount} selected</span>
            <Button className="sbtn" size="small" startIcon={<DoneAllRoundedIcon />}
              onClick={() => handleApproveAll()}>Approve All</Button>
          </Box>
        )}
      </div>
    )}

    {empTimeSheetReports && empTimeSheetReports.length
      ? <div className="wh-mui-accordion">
        {empTimeSheetReports.map((empData, index) => (
          <Accordion key={empData?.EmpName || index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel1-content-${empData?.EmpName}`}
              id={`panel1-header-${empData?.EmpName}`}
            >
              <Checkbox
                onClick={(e) => (e.stopPropagation())}
                checked={selectedEmps.includes(empData?.EmpName)}
                onChange={(e) => handleCheckboxClick(e, empData?.EmpName)}
                inputProps={{ 'aria-label': `Select ${empData?.EmpName}` }}
              />
              <span className="wh-avatar wh-avatar-sm">{initials(empData?.EmpName)}</span>
              <Typography>{empData?.EmpName}</Typography>
              <span className="wh-pill ts-report-count">
                {empData?.reports?.length} {empData?.reports?.length === 1 ? 'week' : 'weeks'}
              </span>
            </AccordionSummary>
            <AccordionDetails>
              <EmpTimeSheetReport reportData={empData?.reports} />
            </AccordionDetails>
          </Accordion>
        ))}
      </div>

      : <NoData
        title="Nothing waiting on you"
        message="Timesheets submitted by your team land here for approval. You are all caught up." />
    }
  </div>
  
};

export default TeamTimeSheets;
